/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const dentalInvestigations = sqliteTable('dental_investigations', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  clinic_id: text('clinic_id'),
  patient_id: text('patient_id'),
  encounter_id: text('encounter_id'),
  type: text('type'),
  findings: text('findings'),
  created_by_user_id: text('created_by_user_id'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
  updated_by: text('updated_by'),
});
